import { render, staticRenderFns } from "./EditInformationLoader.vue?vue&type=template&id=470efa30"
import script from "./EditInformationLoader.vue?vue&type=script&lang=ts"
export * from "./EditInformationLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports